import { blackColor, themePink } from 'theme/color';
import {
  fontsize14,
  fontsize16,
  poppins300,
  poppins400,
  poppins500,
  poppins600,
  poppins700,
} from 'theme/common.style';
import Image from 'assets/images/login-top.png';
import LoginBottom from 'assets/images/login-bottom.png';

export const loginHeader = {
  padding: '1.5em 0px',
};
export const loginHeaderCont = {
  textAlign: 'right',
  paddingRight: '2em',
  paddingTop: '1em',
};
export const loginHeadText = {
  ...poppins300,
  paddingRight: '10px',
  color: themePink,
};
export const loginHeadBtn = {
  ...poppins300,
  borderRadius: '0 px',
  width: '151px',
  color: '#FFFFFF',
  textTransform: 'capitalize',
  // border: "0 px",
  padding: '12px 10px',
  fontSize: '16px',
  minWidth: '100px',
  // fontWeight: "bold",
  // letterSpacing: "2px",
  backgroundImage:
    'linear-gradient(140.46deg, #6C2AD2 -27.13%, #77CFFE 121.57%)',
};

export const loginHeadBtndown = {
  ...poppins400,
  borderRadius: '0px',
  color: '#FFFFFF',
  textTransform: 'capitalize',
  fontSize: '10px',
  minWidth: '70px',
  backgroundImage:
    'linear-gradient(140.46deg, #6C2AD2 -27.13%, #77CFFE 121.57%)',
  marginLeft: '10px',
};

/** Entry point to the admin console from the public login screen. */
export const loginFootMessageDiv = {
  backgroundImage: `url(${LoginBottom})`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'bottom right',
  // justifyContent: "right",
  // backgroundSize:"400px 400px",
  // display: "flex",
  // alignItems:"end",
  // bottom :"0px"
  // flexDirection: "column",
  // marginLeft: "100px",
};
export const loginFooterCont = {
  textAlign: 'right',
  paddingRight: '2em',
  paddingBottom: '1em',
};
export const loginFootCopy = {
  ...poppins300,
  fontSize: '12px !important',
  color: '#000000',
};

export const loginFormCont = {
  paddingLeft: '10em !important',
  paddingTop: '15em !important',
};
export const loginFormMain = {
  backgroundImage: `url(${Image})`,
  backgroundRepeat: 'no-repeat',
};
export const loginFormHeader = {
  ...poppins700,
  color: themePink,
};
export const loginFormHeadersm = {
  fontFamily: 'Poppins !important',
  fontStyle: 'normal !important',
  fontWeight: '600 !important',
  fontSize: '24px !important',
  color: '#1E1E1E',
  color: themePink,
};

export const loginFormBox = {
  paddingBottom: '3.5em',
};
export const loginFormText = {
  ...poppins300,
  paddingTop: '0.3em',
  color: '#000000',
};
export const loginFormTextsm = {
  ...poppins300,
  paddingTop: '0.3em',
  color: '#000000',
  fontSize: '12px',
};
export const loginLabelEmail = {
  ...poppins300,
  color: 'black !important',
  fontWeight: '500 !important',
  paddingBottom: '5px',
  ...fontsize14,
};
export const loginEmailCont = {
  // width: "424px",
  '.MuiInputBase-input': {
    paddingLeft: '0.8em',
    ...poppins300,
  },
  '.MuiFormHelperText-contained': {
    margin: '0',
  },
};
export const loginMailDiv = {
  paddingBottom: '2em',
};
export const loginPassCont = {
  display: 'flex',
  justifyContent: 'space-between',
  // width: "424px",
};
export const forgotPasswordLink = {
  ...poppins300,
  fontSize: '14px',
  color: '#000000',
};

export const remberTextField = () => ({
  '.MuiFormControlLabel-label': {
    ...poppins400,
    fontSize: '14px',
    color: '#737497',
  },
});

export const loginButton = {
  position: 'relative',
  backgroundColor: 'transparent',
  color: '#000',
  border: 'none',
  borderRadius: '2px',

  '&::after': {
    content: '""',
    position: 'absolute',
    inset: 0,
    borderRadius: '2px',
    padding: '1.2px', // ← key fix for 90% zoom
    background: 'linear-gradient(to right, #5FACDF, #6668DB, #C6A7D5)',
    WebkitMask:
      'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
    WebkitMaskComposite: 'xor',
    maskComposite: 'exclude',
    pointerEvents: 'none',
  },
};

export const labelText = {
  ...poppins300,
  color: 'black !important',
  fontWeight: '500 !important',
  paddingBottom: '5px',
};
